import { appSettings } from "core/config";
import UrlUtils from "core/lib/url-utils";
import BaseServiceWithUserTracking from "../base-with-user-tracking.service";

/* This calls the .NET service which in turns calls a CEF api. Most CEF calls have been changed to be made directly. */
class BaseLegacyCefCommercialService extends BaseServiceWithUserTracking {
    setBaseUrl(path: string) {
        const baseUrl = appSettings.urls.utilityService;
        this.baseUrl = UrlUtils.join(baseUrl, `/cef/commercial/${path}`);
    }

    validateCustomerNumber() {
        if (!this.customerNumber) {
            console.error("API Error: Customer Number not found");
        }
    }
}

export default BaseLegacyCefCommercialService;
